export const SAVE_USER_ID = 'SAVE_USER_ID';
export const SAVE_INFO = 'SAVE_INFO';
export const SAVE_EXPIRE = 'SAVE_EXPIRE';
export const UPDATE_INFO = 'UPDATE_INFO';

export const SAVE_EAMIL = 'SAVE_EAMIL';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
